import classNames from 'classnames'
import React from 'react'

import Cta from '@/components/blocks-library/cta/cta'
import Button from '@/components/button/button'
import { toReactNode } from '@/utils/react'

import { useSiteMetadata } from '../root-element'
import * as styles from './centered-call-to-action.module.scss'

type CenteredCallToActionProps = {
  title?: string
  subtitle?: string
  cta?: Queries.CtaFragment
  width?: 'small' | 'medium' | 'full'
}
const CenteredCallToAction: React.FC<CenteredCallToActionProps> = ({
  title,
  subtitle,
  cta,
  width
}) => {
  const { settings } = useSiteMetadata()
  const titleDefault = toReactNode(
    settings['section-subscribe-newsletter-title']
  )
  const subtitleDefault = toReactNode(
    settings['section-subscribe-newsletter-subtitle']
  )

  const columnClass = classNames(
    {
      'col-lg-5': width === 'small' || !width,
      'col-lg-8': width === 'medium',
      'col-lg-12': width === 'full'
    },
    'text-center'
  )
  return (
    <section className={styles.centeredcta}>
      <div className="container">
        <div className="row justify-content-center">
          <div className={columnClass}>
            <h2>{title ?? titleDefault}</h2>
            <p>{subtitle ?? subtitleDefault}</p>
          </div>
        </div>

        <div className="row justify-content-center mt-4">
          <div className="col-lg-7 text-center">
            {cta && <Cta {...cta} color="primary" isBgDark />}
            {!cta && (
              <Button to="/insurance-bulletin/" title="Subscribe" isBgDark />
            )}
          </div>
        </div>
      </div>
    </section>
  )
}

export default CenteredCallToAction
